// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import * as moment from "moment";
import "moment/locale/fr";
import { Tools } from "../helpers/tools-helper";

import { Period } from "./sharedInterfaces";

/**
 *  Events, appointment, scheduled actions that can be registerd in a calendar
 */
/*export interface ScheduledItem {
    start: Date;
    end?: Date;
}*/

/**
 * Corresponds to one date in the agenda with its appointments
 */
export class AgendaCell {
  public appointments: Period[] = [];
  public day: string;
  public isToday = false;
  public hasAppointment = false;
  public dayMoment: moment.Moment;

  /**
   *
   * @param moment
   */
  constructor(dayMoment: moment.Moment) {
    this.day = dayMoment.clone().startOf("day").format();
    this.dayMoment = moment(this.day);
    this.isToday = this.dayMoment.isSame(moment(), "day");
  }

  /**
   *
   * @param apps
   */
  public setAppointments(apps: Period[]) {
    this.appointments = apps;
    this.hasAppointment = this.appointments.length > 0;
  }

  /**
   * Remove appointments
   */
  public resetCellAppointments() {
    this.hasAppointment = false;
    this.appointments = [];
  }
}
/**
 *  Week in a calendar
 *
 */
export class Week {
  public days: AgendaCell[] = [];
  /**
   * Constructor
   * @param firstDay
   */
  constructor(firstDay: moment.Moment) {
    // Here we create the days in the week
    // The moment has to be cloned to avoid any side effect
    firstDay = firstDay.clone().startOf("week");
    this.days.push(new AgendaCell(firstDay));
    let i = 0;
    do {
      firstDay.add(1, "days");
      this.days.push(new AgendaCell(firstDay));
      i++;
    } while (i < 6);
  }

  /**
   *
   * @param appointments
   */
  setAppointments(appointments: Period[]) {
    if (appointments) {
      // clear cells
      for (const cell of this.days) {
        cell.resetCellAppointments();
      }
      // fill with appointments
      for (const appointment of appointments) {
        const start = moment(appointment.start).startOf("day");
        for (const cell of this.days) {
          if (cell.dayMoment.isSame(start)) {
            cell.appointments.push(appointment);
            cell.hasAppointment = true;
            break;
          }
        }
      }
    }
  }
}
/**
 * Month in a calendar.
 * The month
 */
export class Month {
  public weeks: Week[] = [];
  // private apps: Period[];
  public monthAppointments: Period[];
  public remainingRows = [];

  /**
   * Constructor
   * @param month
   * @param year
   */
  constructor(private month?: number, public year?: number) {
    this.init();
  }

  /**
   * Set appointments for this month and each weeks (and so, each cells)
   */
  public setAppointments(appointments: Period[]) {
    this.monthAppointments = new Array<Period>();
    if (Tools.isNotDefined(appointments)) return;
    // order appointments
    appointments = appointments.sort((a1, a2) => (moment(a1.start).isBefore(moment(a2.start)) ? -1 : 1));
    appointments.forEach((appointment) => {
      const appDate = moment(appointment.start);
      if (appDate.month() === this.month && appDate.year() === this.year) {
        this.monthAppointments.push(appointment);
      }
    });
    for (const week of this.weeks) {
      week.setAppointments(this.monthAppointments);
    }
  }

  /**
   * Only return appointments (scheduled items) occuring in the current month
   */
  public getAppointments(): Period[] {
    return this.monthAppointments;
  }

  /**
   *
   */
  get currentMonth(): number {
    return this.month;
  }

  /**
   *
   */
  set currentMonth(month: number) {
    this.month = month;
    this.init();
  }

  /**
   * return first day of this month
   */
  public getFirstDay(): moment.Moment {
    return moment().year(this.year).month(this.month).date(1);
  }

  /**
   *
   */
  private init() {
    this.weeks = [];
    this.monthAppointments = null;
    const firstDate = moment();
    // set as first day in the month
    // This has to be done BEFORE setting the month
    // otherwise we could skip one (eg 29/01 -> 29/3 directly)
    // firstDate.date(1);
    // We only set the year and month if they are defined
    if (Number.isInteger(this.year)) firstDate.year(this.year);
    if (Number.isInteger(this.month)) firstDate.month(this.month);
    // Set month and year again because if month >0 or <1
    // -> year and month are re-avaluated, then
    this.month = firstDate.month();
    this.year = firstDate.year();
    // Set day AGAIN
    // ensure that we still are the first day of the month
    // (could have changed after setting month)
    firstDate.date(1);
    const nextDate = moment(firstDate).startOf("week");
    do {
      this.weeks.push(new Week(nextDate));
      nextDate.add(1, "weeks");
    } while (nextDate.month() === this.month);
    this.remainingRows = new Array<any>(6 - this.weeks.length);
  }
}
